<template>
<div class="chapter">
<div class="inner_page">
<p class="h2a" id="ch5"><a id="page_II.178"></a><a id="page_III.1">STATESMAN</a></p><a id="page_III.1">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226670393_18_ch3.vue?ba308344